<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="8"
      r="8"
      :fill="fill"
    />
    <rect
      width="10.6667"
      height="10.6667"
      transform="translate(2.66797 2.6665)"
      :fill="fill"
    />
    <path d="M8.44705 12.4441H7.11372V11.1108H8.44705V12.4441ZM8.44705 10.2219H7.11372V10.2188C7.11372 9.48542 7.11372 8.85209 7.41238 8.40853C7.64474 8.11405 7.93386 7.86921 8.2626 7.68853C8.41105 7.59342 8.55105 7.5032 8.66883 7.40942C9.18499 7.0099 9.41708 6.34361 9.26083 5.70987C9.01359 5.11882 8.3845 4.78346 7.75598 4.90763C7.12746 5.03181 6.67317 5.58121 6.66927 6.22187H5.33594C5.33594 4.74911 6.52984 3.55519 8.0026 3.55519C9.02716 3.55212 9.96413 4.13251 10.4177 5.0512C10.8251 5.98726 10.6641 7.07361 10.0026 7.8512C9.80149 8.07407 9.57575 8.27342 9.32972 8.44542C9.11442 8.59393 8.91801 8.7681 8.74483 8.96409C8.50007 9.33499 8.39457 9.78059 8.44705 10.2219Z" :fill="iconFill" />
  </svg>
</template>

<script>
export default {
  name: 'IconsQuestions',

  props: {
    type: {
      type: String,
      default: 'default',
      validator: value => ['default'].includes(value)
    },

    fill: {
      type: String,
      default: '#0AC16A'
    },

    iconFill: {
      type: String,
      default: '#FFFFFF'
    }
  }
}
</script>
